import { useEffect, useState } from "react";
import { CloudOff, RefreshCw } from "lucide-react";
import { useAuth } from "../../store/AuthContext";
import { bundleExpiresAt, bundleNow, isOffline, loadBundle, offlineEnabled } from "../../lib/offlineStore";

const ago = (s) => { const m = Math.round((Date.now() - new Date(s).getTime()) / 60000); return m < 1 ? "just now" : m < 60 ? `${m} min ago` : m < 1440 ? `${Math.round(m / 60)} h ago` : `${Math.round(m / 1440)} d ago`; };

// Shown only while a customer with Offline mode is actually cut off from the server.
export const OfflineModeBanner = () => {
  const { user } = useAuth();
  const [, tick] = useState(0);
  useEffect(() => { loadBundle().then(() => tick((n) => n + 1)); const t = setInterval(() => tick((n) => n + 1), 5000); return () => clearInterval(t); }, []);
  if (!user || !(offlineEnabled(user) || user.offline_session)) return null;
  if (!user.offline_session && !isOffline()) return null;
  const b = bundleNow();
  if (!b) return null;
  const exp = bundleExpiresAt(b);
  return (
    <div className="flex items-center gap-3 border-b border-[#f5a524]/50 bg-[#f5a524]/15 px-3 py-2 text-[12.5px] text-[#f5d9a3]" data-testid="offline-mode-banner">
      <CloudOff className="h-4 w-4 flex-shrink-0 text-[#f5c542]" />
      <span className="min-w-0 truncate"><b className="text-[#ffe9b8]">Offline mode</b> — using the {b.vehicles.length} vehicle{b.vehicles.length === 1 ? "" : "s"} saved on this computer (synced {ago(b.synced_at)}). Cuts go straight to Xpattern Software on this PC.{exp ? ` Reconnect before ${exp.toLocaleDateString()} to keep working offline.` : ""}</span>
      <button onClick={() => window.location.reload()} data-testid="offline-retry" className="ml-auto flex flex-shrink-0 items-center gap-1 rounded-md border border-[#f5a524]/60 px-2 py-0.5 text-[11px] font-semibold text-[#ffe9b8] hover:bg-[#f5a524]/25"><RefreshCw className="h-3 w-3" /> Retry connection</button>
    </div>
  );
};
